import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { DailyData } from "@/hooks/admin/attendance/useWeeklyAttendanceStats";
import { useIsMobile } from "@/hooks/use-mobile";

interface WeeklyChartProps {
  data: DailyData[];
}

export const WeeklyChart = ({ data }: WeeklyChartProps) => {
  const isMobile = useIsMobile();
  const hasData = data.some(d => d.count > 0);
  
  if (!hasData) {
    return (
      <div className="h-[150px] sm:h-[200px] flex items-center justify-center text-muted-foreground text-sm">
        Sin ingresos esta semana
      </div>
    );
  }

  const maxCount = Math.max(...data.map(d => d.count), 1);

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const { dayName, dayNumber, count } = payload[0].payload;
      return (
        <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-lg">
          <p className="text-sm font-medium text-foreground">
            {dayName} {dayNumber}
          </p>
          <p className="text-sm text-muted-foreground">
            {count} {count === 1 ? "ingreso" : "ingresos"}
          </p>
        </div>
      );
    }
    return null;
  };

  // Format x-axis label: Mobile shows initial only, desktop shows "Lun 27"
  const tickFormatter = (_: any, index: number) => {
    const item = data[index];
    if (isMobile) {
      // Show only initial: L, M, X, J, V, S, D
      return item.dayName.charAt(0).toUpperCase();
    }
    return `${item.dayName} ${item.dayNumber}`;
  };
  
  return (
    <div className="h-[150px] sm:h-[200px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <XAxis
            dataKey="dayName"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
            tickFormatter={tickFormatter}
            interval={0}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
            allowDecimals={false}
            width={30}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "hsl(var(--muted) / 0.3)" }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={40}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.count > 0 ? "hsl(var(--primary))" : "hsl(var(--muted))"}
                fillOpacity={0.3 + (entry.count / maxCount) * 0.7}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
